import 'amfe-flexible';
import INoBounce from 'inobounce';
import 'babel-polyfill';
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { initMonitorError, sendError } from 'utils/error';
import Es6Promise from 'es6-promise';
import VConsole from 'vconsole';
import DataStorage from 'utils/dataStore';

import {
  Button,
  Cell,
  DatetimePicker,
  IndexList,
  IndexSection,
  Indicator,
  InfiniteScroll,
  Lazyload,
  MessageBox,
  Picker,
  Popup,
  Progress,
  Spinner,
  Swipe,
  SwipeItem,
  Switch,
  Toast,
} from 'mint-ui';
import Env from '@/utils/env';
import 'assets/css/base.scss';
import 'assets/css/common.scss';
import 'assets/css/icon.scss';
import 'assets/css/theme.scss';
import router from './router';
import store from './store';
import App from './App.vue';
import pubMixins from './mixins/pub.js';

Vue.mixin(pubMixins);

// import { getCookie } from './utils/index';
// import { aesEncrypt } from './utils/encrypt';
// 全局Mixin

initMonitorError();

if (process.env.VUE_APP_ENV !== 'production') {
  // eslint-disable-next-line no-new
  new VConsole();
}
Vue.config.errorHandler = function (err) {
  if (Env.isLocal || Env.isDev || Env.isPre) {
    console.log(err);
  } else {
    sendError(err);
  }
};

Es6Promise.polyfill();

// 按需引入部分组件
Vue.component(Button.name, Button);
Vue.component(Toast.name, Toast);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Popup.name, Popup);
Vue.component(MessageBox.name, MessageBox);
Vue.component(Switch.name, Switch);
Vue.component(IndexList.name, IndexList);
Vue.component(IndexSection.name, IndexSection);
Vue.component(Cell.name, Cell);
Vue.component(Picker.name, Picker);
Vue.component(Spinner.name, Spinner);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Progress.name, Progress);
Vue.use(InfiniteScroll);
Vue.use(Lazyload);

Vue.prototype.$toast = Toast;
Vue.prototype.$loading = Indicator;
Vue.prototype.$message = MessageBox;
Vue.prototype.$isMgtvApp = Env.isMgtvApp;
Vue.config.productionTip = false;
/* Vue.directive('title', {
  inserted(el, binding) {
    document.title = binding.value;
  },
}); */

if (Env.isIOS) {
  // 阻止iOS下的橡皮筋效果
  INoBounce.enable();
}

router.beforeEach((to, from, next) => {
  const { isWeixin } = Env;
  if (isWeixin) {
    const { location: { href } } = window;
    /* const arr = [singlemessage', 'timeline', 'groupmessage']; */
    if (href.indexOf('html?') !== -1 && href.indexOf('html?code') === -1) { // 微信会直接在.html后面自动拼接参数
      const allLen = href.length;
      const start = href.indexOf('?');
      const end = href.indexOf('#');
      const str1 = href.substring(0, start);
      const str2 = href.substring(end, allLen);
      window.location.replace(str1 + str2);
      return;
    }
  }
  if (to.name === 'iframe' || from.name === 'iframe') {
    next();
    return;
  }
  if (!to.query.lastp && from.name && !(from.name === to.name)) {
    const query = { ...to.query };
    if (from.name === 'iframe' && from.query.lastp) {
      query.lastp = from.query.lastp;
    } else if (from.name !== to.name) {
      let from_name = from.name;
      if (from_name === 'cfPay') {
        from_name = 'pay';// 众筹支付上报页面改为pay
      }
      query.lastp = `haowu_${from_name}`;
    }
    const jifenParam = DataStorage.getStorage('jifen_shop_home', sessionStorage);
    if (jifenParam) {
      query.from = 'jifen_shop_home';
    }
    const jubaopenParam = DataStorage.getStorage('jubaopen_shop_home', sessionStorage);
    if (jubaopenParam) {
      query.from = 'jubaopen_shop_home';
    }
    next({
      path: to.path,
      query,
    });
  } else {
    next();
  }
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

try {
  Sentry.init({
    dsn: 'http://927c08fcbba247b796c8dbd8231eb6fb@10.43.103.20/16',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
} catch (e) {
  console.log(e);
}
